export default () => {
  return {
    /**
     * Map of unbinding methods
     * @type {Object<string, import('firebase/firestore').Unsubscribe>}
     */
    firestoreUnbindings: {},
  };
};
